(() => {
  const syncReviewBadge = () => {
    const slot = document.querySelector('[data-product-review-slot]');
    const native = document.querySelector('[data-native-review-badge]');
    const approved = document.querySelector('gn-review-badge-source template');
    const source = slot?.dataset.ratingForce !== 'true' && approved?.content.querySelector('.gn-product-rating') ? approved : native;
    if (!slot || !source) return;
    slot.replaceChildren(source.content.cloneNode(true));
    const badge = slot.querySelector('.gn-product-rating');
    if (!badge) return;
    const summary = badge.querySelector('.gn-product-rating__summary');
    if (summary && slot.hasAttribute('data-rating-summary-template')) {
      summary.textContent = slot.dataset.ratingSummaryTemplate.replaceAll('[rating]', badge.dataset.ratingValue || '').replaceAll('[scale]', badge.dataset.ratingScale || '').replaceAll('[count]', badge.dataset.ratingCount || '');
    }
    if (slot.dataset.ratingShowFaces === 'false') {
      badge.querySelector('.gn-product-rating__portraits')?.remove();
      return;
    }
    const avatars = [...document.querySelectorAll('.gn-reviews-v24 .gn-story15-review__author .gn-review-avatar-v25')].slice(0, 3);
    if (!avatars.length) return;
    const portraits = document.createElement('span');
    portraits.className = 'gn-product-rating__portraits gn-product-rating__portraits--reviews';
    portraits.setAttribute('aria-hidden', 'true');
    avatars.forEach(avatar => {
      const face = avatar.cloneNode(true);
      face.className = 'gn-product-rating__face';
      const image = face.querySelector('img');
      image.alt = '';
      image.loading = 'eager';
      image.sizes = '58px';
      portraits.append(face);
    });
    badge.querySelector('.gn-product-rating__portraits')?.remove();
    badge.append(portraits);
    badge.classList.add('gn-product-rating--faces');
  };
  if (!customElements.get('gn-review-badge-source')) {
    customElements.define('gn-review-badge-source', class extends HTMLElement {
      connectedCallback() { queueMicrotask(syncReviewBadge); }
      disconnectedCallback() { queueMicrotask(syncReviewBadge); }
    });
  }
  syncReviewBadge();
  document.addEventListener('shopify:section:load', syncReviewBadge);
  if (!window.Shopify?.designMode) return;
  document.addEventListener('shopify:block:select', event => {
    const block = event.target;
    if (!(block instanceof HTMLElement)) return;
    const details = block.matches('details') ? block : block.closest('details');
    if (details) details.open = true;
    const card = block.closest('[data-carousel-item], [data-ingredient-card]');
    if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
  });
})();
